import {Component, OnDestroy, OnInit} from '@angular/core';
import {HeaderFilterService} from "@Common/widgets/general/data-table/services/header-filter.service";
import {SubSink} from "@Common/core/utils/subsink";
import {DataTableHeaderCommunicationService} from "@Common/widgets/general/data-table";
import {DepositService} from "app/archivage/common/services/deposit/deposit.service";
import {
  FilterDepositDepositsData
} from "app/archivage/common/components/deposit-filters/filter-deposit-deposits/filter-deposit-deposits.model";
import {
  FilterDirCmpDepositsData
} from "app/archivage/common/components/deposit-filters/filter-dir-cmp-deposits/filter-dir-cmp-deposits.model";
import {MatSelectChange} from "@angular/material/select";
import {UntypedFormControl} from "@angular/forms";

@Component({
  selector: 'app-filter-deposit-deposits',
  templateUrl: './filter-deposit-deposits.component.html',
  styleUrls: ['./filter-deposit-deposits.component.scss']
})
export class FilterDepositDepositsComponent extends HeaderFilterService implements OnInit, OnDestroy {
  private subSink = new SubSink();
  deposits: string[];
  selectedDeposits: string[];
  depositControl = new UntypedFormControl([]);

  constructor(public dtCommunicationSvc: DataTableHeaderCommunicationService,
              private depositSvc: DepositService) {
    super(dtCommunicationSvc);
  }

  ngOnInit(): void {
    this.subSink.sink = this.depositSvc.depositBel().subscribe((res)=> this.deposits=res);
    this.selectedDeposits = this.data?.split(',') ?? [];
    this.depositControl.patchValue(this.selectedDeposits);
  }
  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  onCancel(event) {
  }
  onValidate(event) {
    const value = this.selectedDeposits.join(',');
    const dataEmit = <FilterDepositDepositsData>{
      nameComponent: this.name,
      action: 'validate',
      value: value,
      condition: (value) ? `sur ${value}` : ''
    };
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit);
  }
  sendAllReinit(reinit: boolean) {
    this._sendReinit();
  }

  sendReinit(filterName: string) {
    this._sendReinit();
  }
  private _sendReinit() {
    const dataEmit = <FilterDirCmpDepositsData>{nameComponent: this.name, action: 'reinit'};
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit, false);
  }

  onSelected($event: MatSelectChange) {
    console.log('FilterDepositDepositsComponent onSelect: ', $event);
    this.selectedDeposits = $event.value;
  }
}
